import { createContext } from 'react';
import initialBrandUsersState from './initialBrandUsersState';

const BrandUsersContext = createContext(initialBrandUsersState);

export default BrandUsersContext;
